import { ReactNode } from 'react';
import { ComponentPropsWithoutRef } from 'react';

interface Props extends ComponentPropsWithoutRef<'button'> {
  onClick: () => void;
  children: ReactNode;
}

export const ActionButton = ({ onClick, children, ...props }: Props) => {
  return (
    <button {...props} onClick={onClick} className="msq-btn msq-btn-icon-lg msq-btn-secondary">
      {children}
    </button>
  );
};
